export default __webpack_public_path__ + "static/media/vipps-logo.a87ec3dd.jpg";